
import React, { useState, useEffect } from 'react';
import { BASE_URL, instanceAxios, convertDateStr } from "../../config";
import { toast } from "react-toastify";
import Register from './Register';
export default function UserList(props) {
    const [fillData, SetFillData] = useState([]);
    const [FristRecord, SetFristRecord] = useState(1);
    const [EndRecord, SetEndRecord] = useState(20);
    const [totalRecord, SettotalRecord] = useState(0);
    const [showModal, SetShowModal] = useState(false);
    const [UserId, SetUserId] = useState(-1);
    const SaveISAdmin = (Id, value) => {
        let config = {
            mode: 'cors',
            method: 'post',
            url: `${BASE_URL}/UserInfo.ashx`,
            headers: {
                Accept: "application/json",
            },
            data: JSON.stringify({
                Method: 'Update',
                IsAdmin: value === 0 ? 1 : 0,
                Id: Id
            })
        };
        instanceAxios(config)
            .then(function (response) {
                GetListData();
            })
            .catch((err) => {
                toast.warning(err.response ? 'بروز خطا' + err ?.response ?.data ?.msg : 'بروز خطا' + err.message, {
                    closeButton: false,
                    autoClose: 1500
                });
            })
    }  
    const GetListData = () => {
        let config = {
            mode: 'cors',
            method: 'post',
            url: `${BASE_URL}/UserInfo.ashx`,
            headers: {
                Accept: "application/json",
            },
            data: JSON.stringify({
                Method: 'GetListAll',
                FristRecord: FristRecord,
                EndRecord: EndRecord
            })
        };
        instanceAxios(config)
            .then(function (response) {
                if (response.status === 200) {
                    SetFillData(response.data);
                    SettotalRecord(response.data.length);
                }
                else
                    SetFillData([]);
            })
            .catch((err) => {

            })

    }
    const Paging = (state) => {
        switch (state) {
            case "Frist":
                {
                    SetFristRecord(1);
                    SetEndRecord(20);
                    break;
                }
            case "Pre":
                {
                    if (FristRecord != 1) {
                        SetFristRecord(FristRecord - 20);
                        SetEndRecord(EndRecord - 20);
                    }

                    break;
                }
            case "Next":
                {
                    if (totalRecord > EndRecord) {
                        SetFristRecord(FristRecord + 20);
                        SetEndRecord(EndRecord + 20);
                    }
                    break;
                }
            case "Last":
                {
                    var A = totalRecord / 20;
                    SetFristRecord(A * 20);
                    SetEndRecord((A + 1) * 20);
                    break;
                }
                GetListData();
        }
    }
    useEffect(() => {
        GetListData();
    }, [])
    useEffect(() => {
        GetListData();
    }, [showModal])
    return (
        <div className="row">
            <div className="col-lg-12 col-md-12 col-xs-12">
                <div className="box" style={{ borderBottom: "5px solid #b8bec8" }}>
                    <div className="box-header" style={{ borderBottom: "3px solid #b8bec8" }}>
                        <h3 className="box-title"> فهرست کاربران</h3>

                        <div className="box-tools">
                            <div className=" pull-left" style={{ display: 'inline-flex' }}>
                                <div style={{ marginLeft: '10px', marginTop: "auto" }} ><span title="از رکورد" style={{ color: "#e8a7a7" }}> {FristRecord}</span>-<span title="تا رکورد" style={{ color: "#e8a7a7" }}>{EndRecord}</span>/<span style={{ color: "orange" }} title="تعداد کل رکوردها">{totalRecord}</span></div>
                                <div className="btn-group">
                                    <button type="button" title="اولین رکورد" onClick={(e) => Paging('Frist')} className="btn btn-default btn-sm" style={{ fontSize: "14px", backgroundColor: "#e6dcdc", marginLeft: "3px" }}><i className="icon ion-chevron-right"></i><i className="icon ion-chevron-right"></i></button>
                                    <button type="button" title="رکورد قبلی" onClick={(e) => Paging('Pre')} className="btn btn-default btn-sm" style={{ fontSize: "14px", backgroundColor: "#e6dcdc", marginLeft: "3px" }}><i className="icon ion-chevron-right"></i></button>
                                    <button type="button" title="رکورد بعدی" onClick={(e) => Paging('Next')} className="btn btn-default btn-sm" style={{ fontSize: "14px", backgroundColor: "#e6dcdc", marginLeft: "3px" }}><i className="icon ion-chevron-left"></i></button>
                                    <button type="button" title="آخرین رکورد" onClick={(e) => Paging('Last')} className="btn btn-default btn-sm" style={{ fontSize: "14px", backgroundColor: "#e6dcdc", marginLeft: "6px" }}><i className="icon ion-chevron-left"></i><i className="icon ion-chevron-left"></i></button>
                                    <button type="button" title="بروز رسانی فهرست" onClick={(e) => GetListData()} className="btn btn-default btn-sm" style={{ fontSize: "16px", backgroundColor: "#e6dcdc", marginLeft: "3px" }}><i className="icon ion-refresh"></i></button>
                                    <button type="button" title="افزودن کاربر جدید" onClick={(e) => SetShowModal(true)} className="btn btn-default btn-sm" style={{ fontSize: "16px", backgroundColor: "#e6dcdc", marginLeft: "3px" }}><i className="fa fa-plus"></i></button>
                                    
                                </div>

                            </div>
                            <div className="input-group input-group-sm" style={{ width: "150px", marginLeft: "60px" }}>
                                <input type="text" name="table_search" className="form-control pull-right" placeholder="جستجو" />

                                <div className="input-group-btn" >
                                    <button  style={{ backgroundColor: "#e3dcdc" }} className="btn btn-default"><i className="fa fa-search"></i></button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="box-body table-responsive " style={{ minHeight: "calc(80vh)" }}>
                        <table className="table table-hover" >
                            <tr style={{ borderTop: "0px solid currentColor", lineHeight: "45px", backgroundColor: "#f2f29987" }}>
                                <th>ردیف</th>
                                <th>نام و نام خانوادگی</th>
                                <th>تاریخ ثبت</th>
                                <th>ایمیل</th>
                                <th>تلفن</th>
                                <th>ClientIp</th>
                                <th>تصویر کاربری</th>
                                <th >مدیر </th>
                                <th >ویرایش</th>
                            </tr>
                            {
                                fillData !== null && fillData.length != 0 ?
                                    fillData.map((item, i) => {
                                        return <tr key={i} style={{ verticalAlign: "top", borderTop: "1px solid currentColor", lineHeight: "40px", backgroundColor: i % 2 === 0 ? "rgba(218, 232, 236, 0.51)" : "#ddeebe82" }}>
                                            <td style={{ width: "40px", textAlign: "center" }} scope="row">{(i + 1)}</td>
                                            <td>{item.Familly}</td>
                                            <td>{convertDateStr(new Date(item.DateRegister) / 1000, true)}</td>
                                            <td style={{ width: "20vw" }}>{item.Email}</td>
                                            <td>{item.Phone}</td>
                                            <td>{item.ClientIp}</td>
                                            <td><img style={{ maxWidth: "50px", maxHeight: "50px", borderRadius: "40px" }} src={(item.picProfile !== undefined && item.picProfile !== "") ? JSON.parse(item.picProfile)[0].file_image : "img/nopic.jpg"} className="user-image" alt="User Image" ></img></td>
                                            <td className="pull-left">
                                                <i className={item.IsAdmin === 1 ? "icon ion-ios-checkmark" : "icon ion-ios-circle-outline"}
                                                    style={{ fontSize: "22px", color: "rgb(137, 121, 215)", cursor: "pointer", marginLeft: "15px" }}
                                                    onClick={(e) => SaveISAdmin(item.Id, item.IsAdmin)}
                                                ></i>
                                            </td>
                                            <td style={{ textAlign:"center"}}>
                                                <i className="fa fa-edit" style={{ color: "orange", fontSize: "20px", cursor: "pointer" }} onClick={(e) => { SetShowModal(true); SetUserId(item.Id) }} />
                                            </td>
                                        </tr>
                                    })
                                    : <tr style={{ borderTop: "0px solid currentColor", lineHeight: "200px", textAlign: "center", color: "#ac5252" }}><td colSpan={12} ><h4> رکوردی ثبت نشده است</h4>
                                    </td></tr>
                            }

                        </table>
                    </div>
                    <Register SetShowModal={SetShowModal} showModal={showModal} UserId={UserId}/>
                </div>

            </div>
        </div>

    );
}